import { render, staticRenderFns } from "./Fileupload.vue?vue&type=template&id=1a38bd06&"
import script from "./Fileupload.vue?vue&type=script&lang=js&"
export * from "./Fileupload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports